import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { t } from "i18next";

import { MessageBoxGS } from "../components";
import { NewsletterSubscriptionApi, useBackend } from "@imagine/frontend-base";
import { Alert, Spinner } from "@imagine/web-base";

export const NewsletterUnsubscribeContainer = () => {
  const params = useParams<{ token: string }>();
  const backend = useBackend();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);

  const unsubscribe = useCallback(async () => {
    if (!params.token) {
      setSuccess(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    const response = await NewsletterSubscriptionApi.unsubscribe(
      backend,
      params.token,
    );
    setSuccess(response.success);
    setLoading(false);
  }, [backend, params.token]);

  useEffect(() => {
    unsubscribe();
  }, [unsubscribe]);

  return (
    <MessageBoxGS title={t("newsletterUnsubscribeTitle")}>
      {loading && (
        <div className="text-center">
          <Spinner size="lg" />
        </div>
      )}
      {!loading && !success && (
        <Alert color="danger" elementId="newsletter-unsubscribe-failed">
          {t("newsletterUnsubscribeFailed")}
        </Alert>
      )}
      {!loading && success && (
        <h5 id="newsletter-unsubscribe-successful">
          {t("newsletterUnsubscribeSuccess")}
        </h5>
      )}
    </MessageBoxGS>
  );
};
